<template>
    <div v-if="themeStore.themeIndex === 1">
        <NewFirstRechargeOne  :data-set="dataSet" @goToDeposit="goToDeposit" @selectTab="selectTab"/>
    </div>
    <div v-if="themeStore.themeIndex === 2">
        <NewFirstRechargeTwo  :data-set="dataSet" @goToDeposit="goToDeposit" @selectTab="selectTab"/>
    </div>
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    <LoadingScreen ref="loadingRef" />
     <CarteiraView ref="walletPopupRef"/>
</template>
<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { useRouter } from 'vue-router';
import { getActivityInformations } from '@/api/common';
import { useUserStore } from '@/stores/user';
import { getFirstRechargeRewardEligible } from '@/api/deposit';
import NewFirstRechargeOne from '@/themes/themeOne/firstDeposit/newFirstRecharge.vue';
import NewFirstRechargeTwo from '@/themes/themeTwo/firstDeposit/newFirstRecharge.vue';
import { FirstDepositData } from './newFirstRecharge';
import { useThemeStore } from '@/stores/theme';
import CarteiraView from '../carteiraView/carteiraView.vue';

interface ConfigData {
    activeStatus: number;
    day: number;
    recharge_config: any[];
}
interface FirstRechargeData {
    activityIntro: any;
    config: {
        config: [];
        isRewardEligible: boolean
    }
}
const userStore = useUserStore()
const themeStore = useThemeStore()
const router = useRouter();
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const walletPopupRef = ref()

const firstRechargeData = ref<FirstRechargeData>({
    activityIntro: '',
    config: {
        config: [],
        isRewardEligible: false
    }
})

const activityInfo = ref([])
const configList = ref<ConfigData[]>([])
const selectedTabData = ref<any>({})
const isRewardEligible = ref(false)
const bannerIcon = ref('')

const dataSet = computed<FirstDepositData>(() => ({
    activityInfo: activityInfo.value,
    configList: configList.value,
    selectedTabData: selectedTabData.value,
    isRewardEligible: isRewardEligible.value,
    bannerIcon: bannerIcon.value   
}))

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const goToDeposit = () => {
    if (selectedTabData.value?.activeStatus === 1 && isRewardEligible.value) {
        checkFirstRechargeEligible()
    }
}
const getActivityInfo = () => {
    loadingRef.value.open()
    let data = {
        activityId: "daily_first_recharge",
    }
    getActivityInformations(data).then(res => {
        loadingRef.value.close()
        if (res.data) {
            bannerIcon.value = res.data?.floatIcon
            firstRechargeData.value = res.data
            activityInfo.value = JSON.parse(firstRechargeData.value?.activityIntro);
            configList.value = firstRechargeData.value?.config?.config
            isRewardEligible.value = firstRechargeData.value?.config?.isRewardEligible
            let activeTab = configList.value.find((item: any) => item.isToday === true)
            if (activeTab) {
                selectedTabData.value = activeTab
            } else {
                let lengthArray = configList.value?.length
                selectedTabData.value = configList.value[lengthArray - 1]
            }
        }
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}

const selectTab = (item: any) => {
    selectedTabData.value = item
}

const checkFirstRechargeEligible = () => {
    loadingRef.value.open()
    getFirstRechargeRewardEligible().then(res => {
        loadingRef.value.close()
        if(themeStore.themeIndex === 1){
         router.push({ path: '/sd-topup'});
         } else if (themeStore.themeIndex === 2){
            walletPopupRef?.value?.openPopup(0)
         }
        userStore.setisFirstRechargeRewardEligible(res.data)
        userStore.setTakeFirstDeposit(res.data)
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close()
            showError(err)
        }
    });
}
onMounted(() => {
    getActivityInfo()
})
</script>
<style scoped>
.bannerContainer img {
    width: 100%;
}

.bannerContainer {
    padding-top: 50px;
}

.recharge_content {
    padding: 0 25px;
}

.recharge_container {

    background-image: linear-gradient(to bottom, #2a2a2ac9, #feb47b00);
    padding: 10px 15px 0;
    border-radius: 15px;

}

.recharge_container::-webkit-scrollbar {
    display: none;
}

.subContainer {
    max-width: 100%;
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    white-space: nowrap;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.day_num {
    position: relative;
    flex: 0 0 auto;
    justify-content: center;
    width: 20%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.day_num img {
    width: 100%;
}

.numberText {
    color: #D17FFF;
    font-size: 18px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    background-size: cover;
    background-repeat: repeat;
    width: 55px;
    height: 55px;
}

.activeNumText {
    color: #DA009B;
}

.selectIcon {
    display: flex;
    justify-content: center;
}

.selectIcon img {
    height: 15px;
    width: 20px;
}

.detailsCard {
    background-image: linear-gradient(180deg, rgba(44, 50, 56, 0.50) 0%, rgba(32, 38, 45, 0.25) 99%);
    border: 1px solid rgba(249, 196, 134, 0.50);
    border-radius: 15px;
    margin: 0 auto;
    box-sizing: border-box;
    overflow: hidden;
    padding: 0 15px 15px;
}

.cardTitle {
    display: flex;
    align-items: center;
    color: #fff;
    font-size: 15px;
    padding: 10px 0;
}

.titleImage img {
    width: 85%;
}

.textImage img {
    width: 100%;
}

.tableContainer {
    border-radius: 15px;
    background-image: linear-gradient(180deg, rgba(209, 127, 255, 0.50) 2%, rgba(127, 153, 255, 0.50) 100%);
    border: 1px solid #F9C486;
    padding-bottom: 10px;
}

.tableHead {
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.15);
    color: #FFFFFF;
    padding: 10px;
}

.tableTitle {
    display: flex;
    justify-content: center;
    text-align: center;
}

.tabelValue1,
.tabelValue2 {
    padding: 10px;
    color: #ffffff73;
    display: flex;
    align-items: center;
}

.tabelValue1 span {
    font-weight: bold;
    color: #fff;
    font-size: 16px;
    padding: 0 10px;
}

.tabelValue2 span {
    font-weight: bold;
    color: #FFEE00;
    font-size: 16px;
    padding: 0 10px;
}

.depositBtnContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 10px;
}

.statusButton {
    font-size: 15px;
    font-weight: bold;
    background: #514e4e45;
    border-radius: 10px;
    border: 1px solid #ffffff4d;
    width: 100%;
}

.statusButton p {
    margin: 10px 0;
}

.depositBtn {
    color: #000;
    background-image: linear-gradient(99deg, #FCD7A1 0%, #D17836 100%);
    border-radius: 10px;
    padding: 10px;
    width: 75%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 15px;
}

.deposit-disabled {
    color: rgba(255, 255, 255, 0.25);
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.15);
    box-shadow: none;
    border-radius: 10px;
    padding: 10px;
    width: 75%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 15px;
}

.bottom_text {
    padding: 25px;
}

.line1 {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.line2 {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.title {
    color: rgba(255, 255, 255, 0.85);
    font-size: 15px;
    display: flex;
    justify-content: center;
}

.line_text {
    color: rgba(255, 255, 255, 0.45);
    font-size: 14px;
    padding: 10px;
}

@media(min-width: 450px) {
    .numberText {
        width: 65px;
        height: 65px;
    }
}

@media(max-width: 350px) {
    .numberText {
        width: 50px;
        height: 50px;
    }
}
</style>